import mapViewRotationCursorUrl from './map-view-rotation-cursor.svg';

/** Arrow cursor from the recipe cross-section interaction, with its tip hotspot. */
export const VIEW_ROTATION_CURSOR = `url("${mapViewRotationCursorUrl}") 2 2, default`;

/**
 * Arrow shown over interactive map space and selectable buildings.
 * Higher-priority geometry, move, and rotation handles retain their own cursors.
 */
export const getViewRotationHoverCursor = ({
  canRotate,
}: {
  canRotate: boolean;
}): string | undefined => (canRotate ? VIEW_ROTATION_CURSOR : undefined);

/** Keep hover when the building under the stationary pointer becomes selected. */
export const shouldRetainBuildingHoverAfterSelection = (
  hoveredBuildingId: string | undefined,
  selectedBuildingId: string | undefined,
): boolean =>
  hoveredBuildingId !== undefined && hoveredBuildingId === selectedBuildingId;
